import { Role } from './Role';

export class StudyProcedureRoleDefinition {
  constructor(params) {
    this.id = params.id;
    this.notify = params.notify;
    this.role = new Role(params.role);
  }

  listParams({ locked, onClick }) {
    return {
      header: this.role.name,
      id: this.id,
      locked: locked,
      onClick: () => onClick(this.id),
    };
  }
}

export default StudyProcedureRoleDefinition;
